import React, { Component } from "react";

import { Row, Col, Divider, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { ShoppingCartOutlined } from "@ant-design/icons";
import moment from "jalali-moment";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

const bookDetailsText = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#186491",
  fontSize: ".9em",
};
const bookDetailsTextTablet = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#186491",
  fontSize: ".85em",
};
const bookDetailsTextMobile = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#186491",
  fontSize: ".8em",
};

const bookDetailsTextRed = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#ed1c24",
  fontSize: ".9em",
};
const bookDetailsTextRedTablet = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#ed1c24",
  fontSize: ".85em",
};
const bookDetailsTextRedMobile = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#ed1c24",
  fontSize: ".8em",
};

const bookDetailsTitle = {
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "right",
  fontFamily: "IranSans",
  fontSize: ".9em",
};
const bookDetailsTitleTablet = {
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "right",
  fontFamily: "IranSans",
  fontSize: ".9em",
};
const bookDetailsTitleMobile = {
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "right",
  fontFamily: "IranSans",
  fontSize: ".85em",
};

const BooksInsideCard = (props) => {
  return props.size === "laptopdesktop" ? (
    <div
      style={{
        borderRadius: "20px",
        backgroundColor: "#f6f6f6",
        padding: "25px",
      }}
    >
      <Row>
        <Col span={15}>
          <p
            className="bookBorder"
            style={{
              fontFamily: "IranSans",
              fontSize: "1.1em",
              color: "#174561",
              direction: "rtl",
              textAlign: "right",
              paddingRight: "10px",
              paddingTop: "5px",
            }}
          >
            <strong>{props.book.title}</strong>
          </p>
          <Margin top={4}></Margin>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsText}>{props.book.title}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitle}>عنوان</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsText}>{props.book.publisher}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitle}>ناشر</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsText}>{props.book.writer}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitle}>نویسنده</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextRed}> {props.book.publish_date}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitle}>سال انتشار</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextRed}>{props.book.pages}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitle}>تعداد صفحات</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Margin top={4}></Margin>
          <Row>
            <Col span={6}>
              <a
                href="#"
                class="introBtn introBtn-white introBtn-animated"
                style={{
                  fontSize: ".8em",
                  fontFamily: "IRANSans",
                  marginTop: "10px",
                  paddingRight: "30px",
                  paddingLeft: "30px",
                }}
              >
                <ShoppingCartOutlined
                  style={{ color: "#fff", fontSize: "1.5em" }}
                />{" "}
                خرید
              </a>
            </Col>
            <Col span={6}>
              <p
                style={{
                  fontFamily: "IranSans",
                  direction: "rtl",
                  textAlign: "right",
                  paddingRight: "10px",
                  color: "#186491",
                  fontSize: "1.1em",
                  marginTop: "15px",
                }}
              >
                <strong>42900 ریال</strong>
              </p>
            </Col>
            <Col span={6}>
              <p
                style={{
                  fontFamily: "IranSans",
                  direction: "rtl",
                  textAlign: "right",
                  paddingRight: "10px",
                  color: "#186491",
                  fontSize: "1em",
                  textDecoration: "line-through",
                  marginTop: "15px",
                }}
              >
                <strong>52900 ریال</strong>
              </p>
            </Col>
            <Col span={5} style={{ direction: "rtl", textAlign: "right" }}>
              <Row>
                <p
                  style={{
                    fontFamily: "IranSans",
                    direction: "rtl",
                    textAlign: "right",
                    color: "#ed1c24",
                    fontSize: ".9em",
                  }}
                >
                  10% تخفیف:
                </p>
                <p
                  style={{
                    fontFamily: "IranSans",
                    direction: "rtl",
                    textAlign: "right",
                    color: "#ed1c24",
                    fontSize: ".9em",
                    marginTop: "-10px",
                  }}
                >
                  52900 ریال
                </p>
              </Row>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          <Card
            style={{
              borderRadius: "10px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            }}
          >
            <Center>
              <img style={{ width: "100%" }} src={props.book.image} />
            </Center>
          </Card>
        </Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div
      style={{
        borderRadius: "20px",
        backgroundColor: "#f6f6f6",
        padding: "25px",
        opacity: "95%",
      }}
    >
      <Row>
        <Col span={15}>
          <p
            className="bookBorder"
            style={{
              fontFamily: "IranSans",
              fontSize: "1em",
              color: "#174561",
              direction: "rtl",
              textAlign: "right",
              paddingRight: "10px",
              paddingTop: "5px",
            }}
          >
            <strong>{props.book.title}</strong>
          </p>
          <Margin top={4}></Margin>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextTablet}>{props.book.title}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleTablet}>عنوان</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextTablet}>{props.book.publisher}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleTablet}>ناشر</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextTablet}>{props.book.writer}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleTablet}>نویسنده</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextRedTablet}>
                  {" "}
                  {props.book.publish_date}
                </p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleTablet}>سال انتشار</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextRedTablet}>{props.book.pages}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleTablet}>تعداد صفحات</p>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          <Card
            style={{
              borderRadius: "10px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            }}
          >
            <Center>
              <img style={{ width: "100%" }} src={props.book.image} />
            </Center>
          </Card>
        </Col>
        <Row>
          <Col span={10}>
            <a
              href="#"
              class="introBtn introBtn-white introBtn-animated"
              style={{
                fontSize: ".75em",
                fontFamily: "IRANSans",
                marginTop: "10px",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <ShoppingCartOutlined
                style={{ color: "#fff", fontSize: "1.5em" }}
              />{" "}
              خرید
            </a>
          </Col>
          <Col span={1}></Col>
          <Col span={6}>
            <p
              style={{
                fontFamily: "IranSans",
                direction: "rtl",
                textAlign: "right",
                paddingRight: "10px",
                color: "#186491",
                fontSize: "1em",
                marginTop: "15px",
              }}
            >
              <strong>42900 ریال</strong>
            </p>
          </Col>
          <Col span={1}></Col>
          <Col span={6}>
            <p
              style={{
                fontFamily: "IranSans",
                direction: "rtl",
                textAlign: "right",
                paddingRight: "10px",
                color: "#186491",
                fontSize: ".9em",
                textDecoration: "line-through",
                marginTop: "15px",
              }}
            >
              <strong>52900 ریال</strong>
            </p>
          </Col>
        </Row>
      </Row>
    </div>
  ) : (
    <div
      style={{
        borderRadius: "20px",
        backgroundColor: "#f6f6f6",
        padding: "25px",
      }}
    >
      <Row>
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
          }}
        >
          <Center>
            <img style={{ width: "75%" }} src={props.book.image} />
          </Center>
        </Card>
      </Row>
      <Row>
        <Col span={24}>
          <Center>
            <p
              style={{
                fontFamily: "IranSans",
                fontSize: ".85em",
                color: "#174561",
                direction: "rtl",
                textAlign: "right",
                paddingRight: "10px",
                paddingTop: "5px",
                marginTop: "15px",
              }}
            >
              <strong>{props.book.title}</strong>
            </p>
          </Center>
          <Margin top={2}></Margin>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextMobile}>{props.book.title}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleMobile}>عنوان</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextMobile}>{props.book.publisher}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleMobile}>ناشر</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextMobile}>{props.book.writer}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleMobile}>نویسنده</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextRedMobile}>
                  {" "}
                  {props.book.publish_date}
                </p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleMobile}>سال انتشار</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={bookDetailsTextRedMobile}>{props.book.pages}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={bookDetailsTitleMobile}>تعداد صفحات</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={5}></Col>
            <Col span={1}></Col>
            <Col span={6}>
              <p
                style={{
                  fontFamily: "IranSans",
                  direction: "rtl",
                  textAlign: "right",
                  paddingRight: "10px",
                  color: "#186491",
                  fontSize: ".9em",
                  marginTop: "15px",
                }}
              >
                <strong>42900 ریال</strong>
              </p>
            </Col>
            <Col span={6}>
              <p
                style={{
                  fontFamily: "IranSans",
                  direction: "rtl",
                  textAlign: "right",
                  paddingRight: "10px",
                  color: "#186491",
                  fontSize: ".85em",
                  textDecoration: "line-through",
                  marginTop: "15px",
                }}
              >
                <strong>52900 ریال</strong>
              </p>
            </Col>
            <Col
              span={5}
              style={{ direction: "rtl", textAlign: "right" }}
            ></Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={24}>
              <a
                href="#"
                class="introBtn introBtn-white introBtn-animated"
                style={{
                  fontSize: ".75em",
                  fontFamily: "IRANSans",
                  marginTop: "10px",
                  paddingRight: "30px",
                  paddingLeft: "30px",
                }}
              >
                <ShoppingCartOutlined
                  style={{ color: "#fff", fontSize: "1.5em" }}
                />{" "}
                خرید
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default BooksInsideCard;
